import { gql } from 'apollo-angular';
import { cardTaskDetailFragment } from './task.fragments';

export const GoalCardTasksQuery = gql`
  query GoalCardTasksQuery($goalCardIds: [ID!], $status: [CardTaskStatusEnum!]) {
    cardTasks(goalCardIds: $goalCardIds, status: $status) {
      nodes {
        ...CardTaskDetail
      }
    }
  }
  ${cardTaskDetailFragment}
`;

export const EventCardTasksQuery = gql`
  query EventCardTasksQuery($eventCardIds: [ID!], $status: [CardTaskStatusEnum!]) {
    cardTasks(eventCardIds: $eventCardIds, status: $status) {
      nodes {
        ...CardTaskDetail
      }
    }
  }
  ${cardTaskDetailFragment}
`;
